import { Helmet } from "react-helmet";
import { SideBar } from "../side-bar/SideBar";
import { months } from "../../../utils/time.date.utlis";
import { useEffect, useState } from "react";
import { api, getToken } from "../../../services/apis/auth-api/apiUrl";
import { PROCESS_CLIENT_REVENUE_END_POINT, PROCESS_UPDATE_CLIENT_MONTHLY_REV, RECRUITERS_REVENUE_CURRENT_TARGET, RECRUITERS_REVENUE_UPDATE_TARGET } from "../../../config/config";
import goldRibon from './../../../assets/image/gold_ribon.png';
import silverRibon from './../../../assets/image/silver_ribon.png';
import bronzeRibon from './../../../assets/image/bronze_ribon.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight, faCheck, faPenToSquare, faTimes } from "@fortawesome/free-solid-svg-icons";
import CstAdminHeader from "./admin-access-header/CstAdminHeader";

interface clientRevenueProps {
    client_id : number;
    client_name : string;
    target_monthly_rev : {id: number, month: number, rev : number}[];
    recruiters_rev : {month : number, rev : number}[];
    annual_target : number;
    annual_revenue : number;
}

interface clientRevenuePropsExtended extends clientRevenueProps {
    editing : boolean;
}

interface recruitersTargetProps {
    recruiter_id: number; 
    full_name: string; 
    target: number;
}

interface recruitersRevenuePropsExtended extends recruitersTargetProps {
    editing : boolean;
}
const CstRevenueTarget = () => {
    const date = new Date();
    const currentMonth = date.getMonth();
    const currentYear = date.getFullYear();
    const [month, setMonth] = useState<number>(currentMonth);
    const [year, setYear] = useState<number>(currentYear);
    const [loadingData, setLoadingData] = useState<boolean>(true);
    const [clientRevData, setClientRevData] = useState<clientRevenuePropsExtended[] | null>(null);
    const [monthTarget, setMonthTarget] = useState<{id : number, client_id : number, month : number, target : number}[] | null>(null);
    const [recruitersTargetDb, setRecruitersTargetDb] = useState<recruitersTargetProps[] | null>(null);
    const [recruitersTarget, setRecruitersTarget] = useState<recruitersRevenuePropsExtended[] | null>(null);

    const handleUpdateTargetRevenue = async(client_id : number) => {
        try{
            let id: number = 0;
            let target_rev_data = {} as {
                target: number, 
                client_id: number,
                month: number,
                year: number
            }
            if(!monthTarget || !clientRevData) return false;
            for(const target of monthTarget){
                if(target.client_id === client_id && target.month === month){
                    id = target.id;
                    target_rev_data = {
                        target : target.target,
                        client_id : target.client_id,
                        month: month,
                        year: year
                    }
                    break;
                }
            }
            const monthly_rev = await api.post(
                PROCESS_UPDATE_CLIENT_MONTHLY_REV+id, 
                target_rev_data,
                {headers: { 'Authorization': 'Bearer ' + getToken() }}
            )
            const monthly_rev_data = monthly_rev.data as {id: number, month: number, rev : number}[];
            setClientRevData(clientRevData.map(rev => rev.client_id === client_id ? {...rev, target_monthly_rev : monthly_rev_data, editing : false} : rev));
        }catch(e){
            alert('Update failed!');
        }
    }

    const incrementMonth = () => {
        setMonth(prevMonth => (prevMonth + 1) % 12);
        if (month === 11) incrementYear();
    };

    const decrementMonth = () => {
        setMonth(prevMonth => (prevMonth === 0 ? 11 : prevMonth - 1));
        if (month === 0) decrementYear();
    };

    const incrementYear = () => { 
        setYear(prevYear => prevYear + 1)
    };

    const decrementYear = () => {
        setYear(prevYear => prevYear - 1)
    };

    const handleTargetRev = (id:number, target: number) => {
        if(!recruitersTarget) return false;
        setRecruitersTarget(
            recruitersTarget?.map(rev => rev.recruiter_id === id ?
                {...rev, target: target} : rev
            )
        )
    }

    const handleCloseEditing = (id : number) => {
        if(!recruitersTarget || !recruitersTargetDb) return false;
        let original_target = 0;
        for(const org of recruitersTargetDb){
            if(org.recruiter_id === id) {
                original_target =org.target
                break;
            }
        }
        setRecruitersTarget(
            recruitersTarget.map(rev => rev.recruiter_id===id ?
                {...rev, target: original_target, editing : false} :
                rev
            )
        );
    }

    const updateRecruitersTargetRev = async(id : number) => {
        if(!recruitersTarget || !recruitersTargetDb) return false;
        let target_rev = {} as {target_revenue : number};
        for(const rev of recruitersTarget){
            if(rev.recruiter_id === id){
                target_rev.target_revenue = rev.target;
                break;
            }
        }
        try{
            await api.post(
                RECRUITERS_REVENUE_UPDATE_TARGET+id,
                target_rev, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                }
            );
            setRecruitersTargetDb(recruitersTargetDb.map(rev => 
                rev.recruiter_id === id ? {...rev, target : target_rev.target_revenue} : rev
            ));
            setRecruitersTarget(recruitersTarget.map(rev => rev.recruiter_id===id ?
                {...rev, target: target_rev.target_revenue, editing : false} :
                rev
            ));
        }catch(e){
            // const errr = e as AxiosError;
            // alert(errr.response?.status);
            alert('Failed to update target revenue');
        }
    }

    useEffect(()=>{
        const getClientRevData = async() => {
            try{
                const revenue_records = await api.get(
                    PROCESS_CLIENT_REVENUE_END_POINT,{
                        headers : {'Authorization' : 'Bearer '+getToken()}
                    }
                );
                const rev_data = revenue_records.data as clientRevenueProps[];
                const extended_rev_data : clientRevenuePropsExtended[] = rev_data.map(rev => ({...rev, editing : false}));
                setClientRevData(extended_rev_data);
                setLoadingData(false);
            }catch(e){}
        }
        getClientRevData();
    },[]);

    useEffect(()=>{
        const processMonthTarget = () => {
            let monthTarget = [] as {id : number, client_id : number, month : number, target : number}[];
            if(clientRevData === null) return false;
            for(const rev of clientRevData){
                if(rev.target_monthly_rev.length > 0){
                    for(const x of rev.target_monthly_rev){
                        if(month === x.month) monthTarget.push({id : x.id, client_id : rev.client_id, month : x.month, target : x.rev});
                    }
                }else{
                    monthTarget.push({id : 0, client_id : rev.client_id, month : month, target : 0});
                }
            }
            
            setMonthTarget(monthTarget);
        }
        if(clientRevData !== null) processMonthTarget();
    },[clientRevData, month]);

    useEffect(()=>{
        const getRecruitersTarget = async() => {
            try{
                const revenue_records = await api.get(
                    RECRUITERS_REVENUE_CURRENT_TARGET+year+'/'+month,{
                        headers : {'Authorization' : 'Bearer '+getToken()}
                    }
                );
                const rev_data = revenue_records.data as recruitersTargetProps[];
                const extended_rev_data : recruitersRevenuePropsExtended[] = rev_data.map(rev=>({...rev, editing: false}));
                setRecruitersTargetDb(rev_data);
                setRecruitersTarget(extended_rev_data);
            }catch(e){}
        }
        getRecruitersTarget()
    },[month, year])

    return (
        <div className="content flex">
             <Helmet>
                <title>CST Revenue Target</title>
            </Helmet>

            <SideBar />

            <div className='main-content'>
                <div>
                    <h1 className="uppercase">
                        Client services tracker
                    </h1>
                </div>
                <div className="flex flex-col my-4">
                    {/* Client cards */}
                    <div className="bg-white w-full flex p-2">
                        <CstAdminHeader />
                    </div>
                    <div className="flex py-4 bg-white">
                        <div className="ms-auto flex gap-2 items-center mx-2">
                            <div className="flex gap-4 text-xl text-gray-700">
                                <div>
                                    <button className="hover:text-orange-500" onClick={decrementYear}>
                                        <FontAwesomeIcon icon={faAngleLeft} />
                                    </button>
                                </div>
                                <div>
                                    {year ? year : currentYear}
                                </div>
                                <div>
                                    <button className="hover:text-orange-500" onClick={incrementYear}>
                                        <FontAwesomeIcon icon={faAngleRight} />
                                    </button>
                                </div>
                            </div>
                            <div className="hidden">
                                <button type="button" className="button button-vcc-primary text-sm">
                                    Recruiters
                                </button>
                            </div>
                        </div>
                        <div className="flex gap-4 w-40 text-xl text-gray-700">
                            <div>
                                <button onClick={decrementMonth} className="hover:text-orange-500">
                                    <FontAwesomeIcon icon={faAngleLeft} />
                                </button>
                            </div>
                            <div className="w-24 text-center">
                                {months[month]}
                            </div>
                            <div className="ms-auto">
                                <button onClick={incrementMonth} className="hover:text-orange-500">
                                    <FontAwesomeIcon icon={faAngleRight} />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="flex gap-4 py-4">
                        <div className="bg-white p-2 shadow w-full relative">
                            <div>
                                <h2>Clients revenue target</h2>
                            </div>
                            <div className="flex my-2">
                                <div>
                                    <input type="text" className="text-box h-9" placeholder="Search client...." />
                                </div>
                            </div>
                            <div className="table-container">
                                <table className="w-full h-full border">
                                    <thead className="table-fixed-header border">
                                        <tr className="bg-gray-100">
                                            <th className='table-headers font-medium' colSpan={2}></th>
                                            <th className='table-headers font-medium' colSpan={2}>Annual Target</th>
                                            <th className='table-headers font-medium' colSpan={2}>
                                                Monthly Target
                                            </th>
                                            <th className='table-headers font-medium'></th>
                                        </tr>
                                        <tr className="bg-gray-100">
                                            <th className='table-headers font-medium'>Rank</th>
                                            <th className='table-headers font-medium'>Clients</th>
                                            <th className='table-headers font-medium'>Target</th>
                                            <th className='table-headers font-medium'>Revenue</th>
                                            <th className='table-headers font-medium'>Target</th>
                                            <th className='table-headers font-medium'>Revenue</th>
                                            <th className='table-headers font-medium'>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-center">
                                        {loadingData && clientRevData === null ? (
                                            <div></div>
                                        ) : clientRevData?.map(rev => (
                                            <tr className="hover:bg-gray-300">
                                                <td className="table-body text-center py-1">
                                                    <div className="flex items-center justify-center">
                                                        {rev.annual_target >= 2000000 && (<img src={goldRibon} className='w-8' alt=""/>)}
                                                        {rev.annual_target >= 1000000 && rev.annual_target < 2000000 && (<img src={silverRibon} className='w-8' alt=""/>)}
                                                        {rev.annual_target < 1000000 && (<img src={bronzeRibon} className='w-8' alt=""/>)}
                                                    </div>
                                                </td>
                                                <td className="table-body text-center py-1">{rev.client_name}</td>
                                                <td className="table-body text-center py-1">{rev.annual_target.toLocaleString()}</td>
                                                <td className="table-body text-center py-1">{rev.annual_revenue.toLocaleString()}</td>
                                                <td className="table-body text-center py-1">
                                                    {rev.editing ? (
                                                        <input type="number"
                                                            onChange={(e) => {
                                                                setMonthTarget(
                                                                    monthTarget
                                                                        ? monthTarget.map(target =>
                                                                            target.month === month && target.client_id === rev.client_id
                                                                                ? { ...target, target: Number(e.currentTarget.value) }
                                                                                : target
                                                                            )
                                                                        : null
                                                                    );
                                                                }}
                                                            value={(monthTarget?.find(target => target.month === month && target.client_id === rev.client_id)?.target ?? 0)} 
                                                        />
                                                    ) : (rev.target_monthly_rev.find(target => target.month === month)?.rev ?? 0).toLocaleString()}
                                                </td>
                                                <td className="table-body text-center py-1">{(rev.recruiters_rev.find(revenue => revenue.month === month)?.rev ?? 0).toLocaleString()}</td>
                                                <td className="table-body text-center py-1">
                                                    {!rev.editing ? (
                                                        <button type="button" onClick={()=>setClientRevData(clientRevData.map(x=> x.client_id === rev.client_id ? {...x, editing : true} : x))}>
                                                            <FontAwesomeIcon icon={faPenToSquare} />
                                                        </button>
                                                    ) : (
                                                        <div className="flex gap-4 items-center justify-center">
                                                            <button type="button" onClick={()=>handleUpdateTargetRevenue(rev.client_id)}>
                                                                <FontAwesomeIcon icon={faCheck} />
                                                            </button>
                                                            <button type="button" onClick={()=>setClientRevData(clientRevData.map(x=> x.client_id === rev.client_id ? {...x, editing : false} : x))}>
                                                                <FontAwesomeIcon icon={faTimes} />
                                                            </button>
                                                        </div>
                                                    )}
                                                    
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="bg-white p-2 shadow w-full relative">
                            <div>
                                <h2>Recruiters revenue target</h2>
                            </div>
                            <div className="flex my-2">
                                <div>
                                    <input type="text" className="text-box h-9" placeholder="Search recruiters...." />
                                </div>
                            </div>
                        <div className="table-container">
                                <table className="w-full h-full border">
                                    <thead className="table-fixed-header border">
                                        <tr className="bg-gray-100">
                                            <th className='table-headers font-medium'>#</th>
                                            <th className='table-headers font-medium'>Recruiter</th>
                                            <th className='table-headers font-medium'>Target Revenue</th>
                                            <th className='table-headers font-medium'>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-center">
                                        {recruitersTarget === null ? (
                                            <div></div>
                                        ) : recruitersTarget.map((rev, indx) => (
                                            <tr className="hover:bg-gray-300">
                                                <td className="table-body text-center py-1">{indx + 1}</td>
                                                <td className="table-body text-center py-1">{rev.full_name}</td>
                                                <td className="table-body text-center py-1">
                                                    {rev.editing ? (
                                                        <input type="number" onChange={(e)=>handleTargetRev(rev.recruiter_id, parseInt(e.currentTarget.value))} value={rev.target} />
                                                    ) : 
                                                        parseFloat(rev.target.toString()).toLocaleString("en-US", {minimumFractionDigits : 2, maximumFractionDigits : 2})
                                                    }
                                                </td>
                                                <td className="table-body text-center py-1">
                                                    {!rev.editing ? (
                                                        <button type="button" onClick={
                                                            ()=>{
                                                                setRecruitersTarget(recruitersTarget.map(rec=>rec.recruiter_id === rev.recruiter_id ? {...rec, editing : true} : rec))
                                                            }
                                                        }>
                                                            <FontAwesomeIcon icon={faPenToSquare} />
                                                        </button>
                                                    ) : (
                                                        <div className="flex gap-4 items-center justify-center">
                                                            <button type="button" onClick={()=>updateRecruitersTargetRev(rev.recruiter_id)}>
                                                                <FontAwesomeIcon icon={faCheck} />
                                                            </button>
                                                            <button type="button" onClick={()=>handleCloseEditing(rev.recruiter_id)}>
                                                                <FontAwesomeIcon icon={faTimes} />
                                                            </button>
                                                        </div>
                                                    )} 
                                                    
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    );
}

export default CstRevenueTarget;